"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*

function* validateValue() {
    try {
        const value = yield select(ValueSelector);
        yield call(sevice, value);
        yield put(validateValue(value));
    } catch (e) {
        yield put(validateValue(error));
    }
}

export function* watchValidateValue() {
    yield takeEvery(VALIDATE_VALUE_REQUEST, validateValue);
}


*/
var watchers = [//watchValidateValue()
];
var _default = watchers;
exports.default = _default;